import request from 'superagent';
import Cookies from "./Cookies";
import Url from "./Url";

/** Usage Example
 *
 * (new ApiRequest()).get('data', {}, (err, res) => {doSomething(err, res)});
 */

export default class ApiRequest {
    constructor() {
        this.authCredentials = {};
        if (Cookies.check('email') && Cookies.check('token')) {
            this.authCredentials = {
                email: Cookies.get('email'),
                token: Cookies.get('token')
            };
        }
    }

    /**
     * GET API requests
     * @param url
     * @param postData
     * @param callback
     * @param prefix
     */
    post(url, postData = {}, callback = null, prefix = '/api/') {
        let prefixedUrl = this.forceMandyHttpsUrl(prefix + url);
        let req = window.location.href.indexOf('dev.') === -1 ? request.post(prefixedUrl).auth(this.authCredentials.email, this.authCredentials.token) : request.post(prefixedUrl);
        return req
            .set('Accept', 'application/json')
            .set('X-Requested-With', 'XMLHttpRequest')
            .withCredentials()
            .send(postData)
            .end((err, res) => {
                if (!res || (!res.hasOwnProperty('body') && err.status !== 401 && err.status !== 403)) {
                    Bugsnag.notify("Request issue missing request body", "post", { url, data: postData });
                }
                if (err && err.status === 401) {
                    window.location = Url.prefixedUrl(`mandy.com/login`);
                } else {
                    if (err && err.status === 403) {
                        window.location = Url.prefixedUrl(`mandy.com/add-switch-profile?auth=1`);
                    } else {
                        if (callback) {
                            callback(err, res);
                        }
                    }
                }
            });
    }

    /**
     * GET API requests
     * @param url
     * @param query
     * @param callback
     * @param prefix
     */
    get(url, query = {}, callback = null, prefix = '/api/') {
        let prefixedUrl = this.forceMandyHttpsUrl(prefix + url);
        let req = window.location.href.indexOf('dev.') === -1 ? request.get(prefixedUrl).auth(this.authCredentials.email, this.authCredentials.token) : request.get(prefixedUrl);
        return req
            .set('Accept', 'application/json')
            .set('X-Requested-With', 'XMLHttpRequest')
            .withCredentials()
            .query(query)
            .end((err, res) => {
                if (!res || (!res.hasOwnProperty('body') && err.status !== 401 && err.status !== 403)) {
                    Bugsnag.notify("Request issue missing request body", "get", { url });
                }
                if (err && err.status === 401) {
                    window.location = Url.prefixedUrl(`mandy.com/login`);
                } else {
                    if (err && err.status === 403) {
                        window.location = Url.prefixedUrl(`mandy.com/add-switch-profile?auth=1`);
                    } else {
                        if (callback) {
                            callback(err, res);
                        }
                    }
                }
            });
    }

    /**
     * DELETE API requests
     * @param url
     * @param query
     * @param callback
     * @param prefix
     */
    del(url, query = {}, callback = null, prefix = '/api/') {
        let prefixedUrl = this.forceMandyHttpsUrl(prefix + url);
        let req = window.location.href.indexOf('dev.') === -1 ? request.del(prefixedUrl).auth(this.authCredentials.email, this.authCredentials.token) : request.del(prefixedUrl);
        return req
            .set('Accept', 'application/json')
            .set('X-Requested-With', 'XMLHttpRequest')
            .withCredentials()
            .query(query)
            .end((err, res) => {
                if (!res || (!res.hasOwnProperty('body') && err.status !== 401 && err.status !== 403)) {
                    Bugsnag.notify("Request issue missing request body", "del", { url });
                }
                if (err && err.status === 401) {
                    window.location = Url.prefixedUrl(`mandy.com/login`);
                } else {
                    if (err && err.status === 403) {
                        window.location = Url.prefixedUrl(`mandy.com/add-switch-profile?auth=1`);
                    } else {
                        if (callback) {
                            callback(err, res);
                        }
                    }
                }
            });
    }

    /**
     * PUT API requestss
     * @param url
     * @param postData
     * @param callback
     * @param prefix
     */
    put(url, postData = {}, callback = null, prefix = '/api/') {
        postData['_method'] = 'PUT';
        return this.post(url, postData, callback, prefix);
    }

    /**
     * Temporary fix
     * 
     * @param {*} url 
     */
    forceMandyHttpsUrl(url) {
        if (window.env === 'production') {
            return 'https://www.mandy.com' + url;
        }
        return url;
    }
}